import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';
import { buildLegacyIframeView } from './utils/legacy-iframe-view.util';

@Injectable({ providedIn: 'root' })
export class ProcessesListViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const view = this.getView(route);
    if (view) {
      return this.routeGuardService.handleRoute(view);
    }
    return Promise.resolve(true);
  }

  getView(route?: ActivatedRouteSnapshot): View {
    return buildLegacyIframeView(route, 'processes', 'processes');
  }
}
